import { createSlice } from "@reduxjs/toolkit";
import urlStorage from "src/helper/urlStorage";
const urlList = urlStorage.getItem('qt');

const initialState = {
    filterList: urlList ? urlList : []
};

const slice = createSlice({
    name: "filterSelection",
    initialState: initialState,
    reducers: {
        setFilterList: {
            reducer: (state, action) => {
                state.filterList = action.payload
            },
        },
        clearFilterByKey: {
            reducer: (state, action) => {
                state.filterList.splice(action.payload, 1);
                return state;
            },
        },
        clearAllFilter: {
            reducer: (state, action) => {
                state.filterList = [];
                return state;
            },
        },
    },
});

export let { setFilterList, clearFilterByKey, clearAllFilter } = slice.actions;

export default slice.reducer;
